module.exports = __webpack_public_path__ + "img/collectible_card.3f38b15e.jpg";